import { useEffect, useState } from 'react';
import '../css/manageuser.css';
import Header from '../components/header';
import SuperAdminMine from '../components/SuperAdminMine';
import { fetchUsers } from '../Utility/Mines/manageMinesFunctions';

function ManageMines() {
    const [mines, setMines] = useState([]);
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(null); 

    useEffect(() => {
        fetchUsers(setMines, setError, setLoading);
    }, []);

    
    return (
        <>
            <Header />
            <div className="riga">
                <h3 className="titolo titoloManage">MANAGE MINES</h3>
                <span className="description text">
                </span>
                <div className="space"></div>
            </div>
            <div className="riga space-bottom">
                {loading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <p className="error">{error}</p> 
                ) : (
                    mines.map((mine) => (
                        <div key={mine._id}>
                            <SuperAdminMine
                                id={mine._id}
                                email={mine.admin.email}
                                name={mine.name}
                                collaborators={mine.users.length}
                                tokens={mine.tokens}
                            />
                        </div>
                    ))
                )}
                <div className="space"></div>
            </div>
        </>
    );
}

export default ManageMines;
